<template>
  <div class="pageStyle">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>结算资料</span>
        <span>编辑您的结算信息</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="content">
      <div class="information">
        <div class="upload-idphoto-text">*点击图片上传您的身份证原件照片</div>
        <!-- 照片上传 -->
        <div class="upload-idphoto-Bigbox">
          <!-- 人像面 -->
          <div class="upload-idphoto-box">
            <div v-show="ShowBlackBackImg" class="upload-idphoto-box-loading">
              <Loading color="#1989fa" size="24px">上传中...</Loading>
            </div>
            <Uploader
              v-model="idBack"
              accept="image/*"
              :max-count="1"
              :after-read="UploadBackPhoto"
              :before-delete="DeleteBackPhoto"
            >
            </Uploader>
            <p>人像面</p>
          </div>
          <!-- 国徽面 -->
          <div class="upload-idphoto-box">
            <div v-show="ShowBlackFrontImg" class="upload-idphoto-box-loading">
              <Loading color="#1989fa" size="24px">上传中...</Loading>
            </div>
            <Uploader
              v-model="idFront"
              accept="image/*"
              :max-count="1"
              :after-read="UploadFrontPhoto"
              :before-delete="DeleteFrontPhoto"
            >
            </Uploader>
            <p>国徽面</p>
          </div>
        </div>
        <!-- 表单内容 -->
        <Form @submit="UploadInformation">
          <Field
            :value="form.name"
            placeholder="请上传身份证照片"
            label="姓名"
            disabled
          />
          <Field
            :value="form.idNum"
            placeholder="请上传身份证照片"
            label="身份证号码"
            disabled
          />
          <Field
            rows="1"
            autosize
            type="textarea"
            :value="form.address"
            placeholder="请上传身份证照片"
            label="身份证住址"
            disabled
          />
          <Field
            v-model="form.bankNum"
            clearable
            type="number"
            label="银行卡号"
            right-icon="warning-o"
            placeholder="请填写银行卡号"
            :rules="[{ required: true, message: '请填写银行卡号' }]"
          />
          <Field
            v-model="form.bankName"
            clearable
            label="银行名称"
            right-icon="warning-o"
            placeholder="例如：中国建设银行"
            :rules="[{ required: true, message: '请填写银行名称' }]"
          />
          <!-- <Field
            v-model="SubBranch"
            clearable
            label="所属支行"
            right-icon="warning-o"
            placeholder="例如：广州东华路支行"
            :rules="[{ required: true, message: '请填写所属支行' }]"
          /> -->
          <!-- <Field
            :value="form.area"
            @click="ShowPopup"
            readonly
            label="业务地区"
            right-icon="warning-o"
            placeholder="请选择业务地区"
            :rules="[{ required: true, message: '请选择业务地区' }]"
          /> -->
          <Field
            v-model="form.phone"
            clearable
            type="number"
            label="实名手机号"
            placeholder="请填写实名手机号"
            :rules="[
              { required: true, message: '请填写实名认证手机号' },
              { pattern: /^\d{11}$/, message: '请输入正确的手机号码' },
            ]"
          />
          <Field
            v-model="form.VerificationCode"
            center
            clearable
            type="number"
            label="短信验证码"
            maxlength="6"
            placeholder="请填写短信验证码"
            :rules="[{ required: true, message: '请填写短信验证码' }]"
          >
            <template #button>
              <Button
                class="VerificationBtn"
                native-type="button"
                @click="GetVerificationCode"
                size="small"
                type="primary"
                style="with: 72px"
                >{{ VerificationTxt }}</Button
              >
            </template>
          </Field>
          <!-- 提交按钮 -->
          <div class="submitBtn">
            <Button type="info" :class="form.BtnClass" native-type="submit"
              >提交</Button
            >
          </div>
        </Form>
      </div>
    </div>
    <Popup
      round
      v-model="PopupShow"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <Area
        title="选择地区"
        :columns-num="2"
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </Popup>
  </div>
</template>

<script>
import {
  uploadIdImg,
  updateXcChannelPayInfo,
  findXcChannelPayInfoById,
} from "@/api/accountCenter.js";
import { sendSms, smsValid } from "@/api/login.js";
import { areaList } from "@vant/area-data";
import {
  Button,
  Uploader,
  Form,
  Field,
  Toast,
  Popup,
  Area,
  Notify,
} from "vant";
import { getCurrentChannelInfo } from "@/api/login.js";
import * as imageConversion from "image-conversion";
export default {
  components: {
    Button,
    Uploader,
    Form,
    Field,
    Popup,
    Area,
    Notify,
  },
  mounted() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    // 获取渠道用户信息
    getCurrentChannelInfo()
      .then((res) => {
        this.form.channelId = res.id;
        let id = this.$route.query.id;
        // 判断是否有id 有id则为修改 获取结算账户信息
        if (id) {
          // 获取结算账户信息
          findXcChannelPayInfoById(id)
            .then((ress) => {
              console.log("ress", ress);
              Toast.clear();
              this.form = ress;
              this.idBack.push({ url: ress.idBack });
              this.idFront.push({ url: ress.idFront });
            })
            .catch((err) => {
              console.log("Err", err);
              Toast.clear();
            });
        } else {
          Toast.clear();
        }
      })
      .catch((err) => {
        console.log("Err", err);
        Toast.clear();
      });
  },
  data() {
    return {
      form: {
        //oepnId
        openId: "",
        // 姓名
        name: "",
        // 身份证号码
        idNum: "",
        // 身份证住址
        address: "",
        // 银行卡卡号
        bankNum: "",
        // 银行卡手机号
        phone: "",
        // 所属支行
        bankName: "",
        // 国徽面图片上传
        idFront: "",
        // 人像面图片上传
        idBack: "",
        // 验证码
        VerificationCode: "",
        // 业务地区
        // area: "",
      },
      // 本地储存的上传照片
      // 国徽面
      idFront: [],
      // 人像面
      idBack: [],
      // 验证码计时器
      SetTime: null,
      // 验证码倒计时文字
      VerificationTxt: "获取验证码",
      // 控制黑幕->上传中
      // 国徽面
      ShowBlackFrontImg: false,
      // 人像面
      ShowBlackBackImg: false,
      // 提交按钮的文字
      BtnTxt: "",
      // 银行名称
      BankName: "",
      // 所属支行
      // SubBranch: "",
      // 选择地区的弹窗显示
      PopupShow: false,
      // 地区数据
      areaList,
    };
  },
  methods: {
    // 选择地区的弹窗显示
    ShowPopup() {
      this.PopupShow = true;
    },
    //确定选择城市
    onConfirm(val) {
      this.form.area = val
        .map((item) => {
          return item.name;
        })
        .join("/");
      this.PopupShow = false; //关闭弹框
    },
    //取消选中城市
    onCancel() {
      this.form.area = "";
      this.PopupShow = false;
    },

    // form表单提交，全部填写才触发(不包括身份证照片)
    UploadInformation() {
      // 合并 银行名称 和 所属支行 的内容
      // this.form.bankName = this.BankName + this.SubBranch;
      // CheckPhoto方法判断身份证照片上传
      if (this.CheckPhoto()) {
        // 身份证信息不为空，则验证短信和手机
        //验证短信
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        // 对比验证码和对应手机号,返回true则提交信息
        smsValid(this.form.phone, this.form.VerificationCode)
          .then((res) => {
            if (res.token) {
              //提交信息
              updateXcChannelPayInfo(this.form)
                .then((res) => {
                  console.log("提交结果", res);
                  Toast.clear();
                  Notify({ type: "success", message: "新增成功" });
                  // 提交成功后跳转回页面
                  this.$router.replace({
                    name: "accountCenter",
                  });
                })
                .catch(() => {
                  Toast.clear();
                  Notify({ type: "danger", message: "提交失败" });
                });
            } else {
              Toast.clear();
              Notify({ type: "danger", message: "验证码错误" });
            }
          })
          .catch((err) => {
            console.log("err", err);
            Toast.clear();
          });
      }
    },

    // 检查身份证照片上传情况，删除照片时DeletePhoto会清空照片信息
    CheckPhoto() {
      if (!this.form.idBack) {
        Toast.fail("请上传身份证人像面");
      } else if (!this.form.idFront) {
        Toast.fail("请上传身份证国徽面");
      } else {
        return true;
      }
    },

    // "获取验证码"按钮
    GetVerificationCode() {
      let phone = this.form.phone;
      // 检查手机号码的长度，11位数则提交
      if (phone.length == 11) {
        // 计时器为空则执行，防止重复计时
        if (this.SetTime != null) {
          Toast.fail("请勿重复点击");
          return;
        }
        // 倒计时按钮倒数文字处理-->调用计时器方法
        this.SetTimeMode();
        // 返回值200则发送成功，400提示频繁
        sendSms(phone)
          .then((res) => {
            // console.log(res);
            if (res.code == 200) {
              Toast.success("验证码已发送");
            } else {
              Toast.fail("短信发送失败");
            }
          })
          .catch(() => {});
      } else {
        Toast.fail("请输入手机号码");
      }
    },
    // 验证码按钮计时器方法
    SetTimeMode() {
      // 初始化倒计时时间
      let time = 60;
      this.SetTime = setInterval(() => {
        // 倒计时为1则初始化按钮文字，清除定时器，初始化定时器
        if (time == 1) {
          this.VerificationTxt = "获取验证码";
          clearInterval(this.SetTime);
          this.SetTime = null;
          // console.log(this.VerificationTxt);
        }
        // 倒计时不为1则自减,按钮文字改为倒计时
        else {
          time--;
          this.VerificationTxt = time + "s";
          // console.log(this.VerificationTxt);
        }
      }, 1000);
    },

    // 身份证上传------
    // 国徽面
    UploadFrontPhoto(file) {
      // 显示上传中遮罩层
      this.ShowBlackFrontImg = true;
      imageConversion.compressAccurately(file.file, 400).then((res) => {
        console.log("res", res);
        let img = new File([res], file.file.name, {
          type: file.file.type,
        });
        let data = new FormData();
        data.append("file", img);
        uploadIdImg(data)
          .then((res) => {
            this.ShowBlackFrontImg = false;
            Toast.success("请核对身份信息");
            // 赋值图片地址
            this.form.idFront = res.img;
          }) // 关闭遮罩层，清空已经上传到本地的图片
          .catch(() => {
            Toast.fail("上传失败");
            this.ShowBlackFrontImg = false;
            this.idFront = [];
            this.form.idFront = "";
          });
      });
    },
    // 人像面
    UploadBackPhoto(file) {
      // 显示上传中遮罩层
      this.ShowBlackBackImg = true;

      imageConversion.compressAccurately(file.file, 400).then((res) => {
        console.log("res", res);
        let img = new File([res], file.file.name, {
          type: file.file.type,
        });
        let data = new FormData();
        data.append("file", img);
        uploadIdImg(data)
          .then((res) => {
            // 获取完数据后，去除遮罩层
            this.ShowBlackBackImg = false;
            Toast.success("请核对身份信息");
            // 赋值给姓名
            this.form.name = res.ocr.name;
            // 身份证号码
            this.form.idNum = res.ocr.idNum;
            // 图片图片地址
            this.form.idBack = res.img;
            // 身份证住址
            this.form.address = res.ocr.address;
            // console.log(res.ocr);
          })
          // 关闭遮罩层，清空已经上传到本地的图片
          .catch(() => {
            Toast.fail("上传失败");
            this.ShowBlackBackImg = false;
            this.idBack = [];
            this.form.idBack = "";
          });
      });
    },

    // 删除国徽面照片
    DeleteFrontPhoto() {
      this.form.idFront = "";
      // 清空已经上传到本地的国徽面
      this.idFront = [];
      return true;
    },
    // 删除人像面照片
    DeleteBackPhoto() {
      this.form.idBack = "";
      // 清空姓名
      this.form.name = "";
      // 清空身份证号码
      this.form.idNum = "";
      // 清空身份证住址
      this.form.address = "";
      // 清空已经上传到本地的人像面
      this.idBack = [];
      return true;
    },
  },
};
</script>

<style scoped>
body {
  /* background-color: #f4f4f4; */
  box-sizing: border-box;
}

.pageStyle {
  /* height: 100%; */
  /* padding: 0 4vw 4vw 4vw; */
  /* background-color: #f4f9fc; */
  box-sizing: border-box;
}
.top-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 80vw;
  background-image: linear-gradient(to bottom, #1b5dd9 50%, white 100%);
  z-index: -1;
}

.top-title {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 8vw 0;
  color: white;
  padding-left: 4vw;
}

.top-title div:nth-of-type(1) {
  display: grid;
  gap: 2vw;
}

.top-title div:nth-of-type(1) span:nth-of-type(1) {
  letter-spacing: 4px;
  font-weight: 600;
  font-size: 8vw;
  /* color: #4988fd; */
}

.top-title div:nth-of-type(1) span:nth-of-type(2) {
  /* font-weight: 600; */
  font-size: 4vw;
  /* color: #4988fd; */
}

.top-title div:nth-of-type(2) {
  position: absolute;
  top: 0;
  right: 0;
  height: 40vw;
}

.top-title div:nth-of-type(2) img {
  height: 100%;
  opacity: 0.6;
}
.content {
  padding: 0 4vw 4vw 4vw;
}
.information {
  width: 100%;
  padding: 4vw;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 14px;
  box-shadow: 0 2.133vw 4.8vw -2.133vw #aebcca;
}

/* 头部文字 */
.upload-idphoto-text {
  height: 8vw;
  line-height: 8vw;
  text-align: center;
  font-size: 4vw;
}

/* 照片上传 */
.upload-idphoto-Bigbox {
  display: flex;
  margin-top: 10px;
  /* height: 40vw; */
  margin-bottom: 10px;
  width: 100%;
  gap: 4vw;
}

.upload-idphoto-box {
  box-sizing: border-box;
  position: relative;
  height: 37vw;
  width: 100%;
}

.upload-idphoto-box:nth-of-type(2) {
}

.upload-idphoto-box p {
  position: absolute;
  bottom: 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  width: 100%;
  margin: 0 auto;
  line-height: 6vw;
  padding: 2px 0;
}

/* 上传遮罩层 */
.upload-idphoto-box:nth-child(1) .upload-idphoto-box-loading {
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 37vw;
  color: #1989fa;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-idphoto-box:nth-child(2) .upload-idphoto-box-loading {
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 37vw;
  color: #1989fa;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-idphoto-box >>> .van-loading {
  top: 40%;
}

.upload-idphoto-box >>> .van-loading span {
  color: white;
}

/* 国徽面和人像面背景图 */
.upload-idphoto-box >>> .van-uploader__upload {
  width: 100%;
  height: 37vw;
  margin: 0;
  background-image: url("https://static.xchengtech.cn/ed40c83caf9943699d4b47545b407ba1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

/* 国徽面背景图 */
.upload-idphoto-box:nth-child(1) >>> .van-uploader,
.upload-idphoto-box:nth-child(2) >>> .van-uploader {
  width: 100%;
}

.upload-idphoto-box:nth-child(2) >>> .van-uploader__upload {
  background-image: url("https://static.xchengtech.cn/76372efdec9b42b98f0354431f837b6c.png");
}

/* 上传之后的照片样式 */
.upload-idphoto-box >>> .van-image {
  width: 100%;
  height: 37vw;
}

/* 上传图片删除按钮 */
.upload-idphoto-box >>> .van-uploader__preview-delete {
  width: 18px;
  height: 18px;
  border-radius: 0 0 0 16px;
}

.upload-idphoto-box >>> .van-uploader__preview-delete-icon {
  font-size: 18px;
}

.upload-idphoto-box >>> .van-uploader__preview {
  margin: 0;
}

/* 小相机颜色 */
.upload-idphoto-box >>> .van-icon-photograph {
  color: #585bb4;
}

/* 步骤条 */
.van-steps--horizontal {
  padding: 10px 16px 0;
}

/* 身份证信息填写 */

.information >>> .van-cell {
  width: 100%;
  /* padding: 10px 0; */
  padding: 10px 0;
  border-bottom: 1px solid #ebedf0;
}

.information >>> .van-field__label {
  width: 30%;
}

.van-cell::after {
  border: none;
}

/* 提交按钮 */
.submitBtn {
  padding-top: 4vw;
  box-sizing: border-box;
  background-color: #fff;
}

.submitBtn .van-button {
  width: 100%;
  background-color: #4988fd;
  color: white;
  border-radius: 8px;
  font-weight: 600;
  height: 48px;
  font-size: 4vw;
}

/* 获取验证码按钮 */
.information .VerificationBtn {
  width: 78px;
}
</style>



// WEBPACK FOOTER //
// src/view/accountCenter/module/authentication.vue